import React, { useState, useContext } from 'react';
import { Box, Text, Button, DropButton, CheckBox, ThemeContext } from 'grommet';
import { Close, MoreVertical } from 'grommet-icons';
import Divider from 'granite-admin/core/components/Divider';
const DropContent = ({
  onClose,
  setCheckBoxArray,
  checkBoxChangeHandlder,
  checkBoxArray,
  submitFilterHandler,
  tableOptionsArray
}) => /*#__PURE__*/React.createElement(Box, {
  overflow: "hidden"
}, /*#__PURE__*/React.createElement(Box, {
  direction: "row",
  pad: "xsmall",
  justify: "between",
  align: "center"
}, /*#__PURE__*/React.createElement(Text, {
  weight: "bold",
  margin: {
    right: '14px'
  },
  size: "14px"
}, "Show/Hide Columns"), /*#__PURE__*/React.createElement(Button, {
  icon: /*#__PURE__*/React.createElement(Close, {
    size: "12px"
  }),
  onClick: onClose
})), /*#__PURE__*/React.createElement(Divider, {
  style: {
    width: 'auto',
    minWidth: 'auto'
  },
  color: "#c6c6c6",
  background: {
    color: 'border',
    opacity: 'medium'
  }
}), /*#__PURE__*/React.createElement(Box, {
  pad: "small",
  gap: "medium",
  overflow: {
    vertical: 'scroll'
  },
  height: {
    max: 'small'
  },
  margin: {
    bottom: 'xsmall'
  },
  width: {
    min: 'medium-s'
  }
}, tableOptionsArray.map((i, index) => /*#__PURE__*/React.createElement(CheckBox, {
  key: i.id,
  defaultChecked: checkBoxArray.includes(i.id),
  label: /*#__PURE__*/React.createElement(Text, {
    size: "large"
  }, i.Header),
  onChange: e => {
    let data = e.target.checked ? [...new Set([...checkBoxArray, i.id])] : checkBoxArray.filter(el => el !== i.id);
    setCheckBoxArray(data);
    checkBoxChangeHandlder(data);
  }
}))), /*#__PURE__*/React.createElement(Box, {
  flex: {
    shrink: 0
  },
  margin: "xsmall",
  direction: "row",
  justify: "end"
}, /*#__PURE__*/React.createElement(Box, {
  width: "50%"
}, /*#__PURE__*/React.createElement(Button, {
  disabled: !checkBoxArray.length,
  primary: true,
  size: "small",
  onClick: submitFilterHandler,
  label: "Apply"
}))));
const FiltersDropButton = ({
  tableCols = [],
  showHideColsHandler,
  hiddenColumnsArray: defaultHiddenCols = [],
  disableHideCells = []
}) => {
  const [open, setOpen] = useState();
  const {
    graniteTable
  } = useContext(ThemeContext) ?? {};
  const {
    filtersDropButtonProps
  } = graniteTable ?? {};
  const [hiddenColumnsArray, setHiddenColumnsArray] = useState(defaultHiddenCols);
  const onOpen = () => {
    setOpen(true);
  };
  const checkBoxChangeHandlder = id => {
    let filteredList = tableOptionsArray.filter(x => !id.includes(x.id)).map(x => x.id);
    setSelectedFilterColumns(filteredList);
  };
  const tableOptionsArray = tableCols.filter(x => {
    if (x.hideColumnsLabel) {
      if (disableHideCells.length > 0) return !disableHideCells.includes(x.hideColumnsLabel);
      return x.hideColumnsLabel;
    }
  }).map(x => {
    if (x.hideColumnsLabel) {
      if (x.hideColumnsLabel === 'ID' || x.hideColumnsLabel === 'Id') {
        return {
          Header: x.hideColumnsLabel.toUpperCase(),
          id: x.id || 'pk'
        };
      }
      if (x.hideColumnsLabel !== '' && x.hideColumnsLabel !== undefined && typeof x.hideColumnsLabel !== 'function') {
        return {
          id: x.id,
          Header: x.hideColumnsLabel
        };
      }
      return {
        id: x.id,
        Header: x.hideColumnsLabel
      };
    }
  });
  let tableColsIdArray = tableOptionsArray.map(x => x.id);
  const [checkBoxArray, setCheckBoxArray] = useState(tableColsIdArray.filter(x => !hiddenColumnsArray.includes(x)));
  const [selectedFilterColumns, setSelectedFilterColumns] = useState(hiddenColumnsArray);
  const onClose = () => {
    setOpen(false);
    setSelectedFilterColumns(hiddenColumnsArray);
    setCheckBoxArray(tableColsIdArray.filter(x => !hiddenColumnsArray.includes(x)));
  };
  const submitFilterHandler = () => {
    setHiddenColumnsArray(selectedFilterColumns);
    showHideColsHandler(selectedFilterColumns);
    setOpen(false);
  };
  return /*#__PURE__*/React.createElement(DropButton, {
    className: filtersDropButtonProps.className,
    open: open,
    onOpen: onOpen,
    onClose: onClose,
    dropContent: /*#__PURE__*/React.createElement(DropContent, {
      checkBoxArray: checkBoxArray,
      submitFilterHandler: submitFilterHandler,
      setCheckBoxArray: setCheckBoxArray,
      checkBoxChangeHandlder: checkBoxChangeHandlder,
      onClose: onClose,
      tableOptionsArray: tableOptionsArray
      // tableOptionsArray={[]}
    }),

    dropProps: filtersDropButtonProps?.dropProps
  }, /*#__PURE__*/React.createElement(MoreVertical, {
    size: filtersDropButtonProps.iconSize,
    color: filtersDropButtonProps.iconColor
  }));
};
export default FiltersDropButton;